import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsReportsUnsubscribeEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-assets-reports-unsubscribe/src/assetsReportsUnsubscribeEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { assetsReportsUnsubscribeRoute } from '@jira/router-routes__assets-app-routes/src/assetsReportsUnsubscribeRoute.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';

import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsReportsUnsubscribePageEntryPoint = createChromelessEntryPoint({
	main: assetsReportsUnsubscribeEntryPoint,
});

export const assetsReportsUnsubscribeRouteEntry: Route = createEntry(
	assetsReportsUnsubscribeRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		entryPoint: () => assetsReportsUnsubscribePageEntryPoint,
		pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe',
		resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
		forPaint: [LazyAssetsLayout],
		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
				packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
				teamName: 'ITSM SAGA',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
